// @flow
import * as React from "react"
import NitroCloseByKey from "@kiwicom/nitro/lib/components/CloseByKey"

type Props = {
  onClose: (?Event) => void,
  children: ?React.Element<*>,
}

const CloseByKey = ({ children, onClose }: Props) => (
  <NitroCloseByKey onClose={onClose}>{children || null}</NitroCloseByKey>
)

export default CloseByKey
